import * as React from 'react'
import { Container } from '../Container'
import { LandingPageButton } from '../LandingPageButton'
import { GraySection } from '../GraySection'

type Props = {
  title: string
  buttonText: string
  description: string
}
export const SkipTheShopSection: React.FC<Props> = ({ description, title, buttonText }) => (
  <GraySection className="text-center">
    <Container>
      <h2 className="title">{title}</h2>
      <p className="description">{description}</p>
      <LandingPageButton buttonText={buttonText} />
    </Container>
  </GraySection>
)
